import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import { api } from "../Constant";
import toast from "react-hot-toast";

export const MovieContext = createContext();

const MovieProvider = ({ children }) => {
  const [movies, setMovies] = useState([]);
  const [watchlist, setWatchlist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const userEmail = localStorage.getItem("email");

  useEffect(() => {
    console.log(userEmail);
    const storedWatchlist =
      JSON.parse(localStorage.getItem(`watchlist_${userEmail}`)) || [];
    setWatchlist(storedWatchlist);
  }, [userEmail]);

  useEffect(() => {
    // Check if watchlist is not empty before updating local storage
    if (watchlist.length > 0) {
      localStorage.setItem(`watchlist_${userEmail}`, JSON.stringify(watchlist));
    }
  }, [watchlist, userEmail]);

  const fetchMovies = async (title) => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `https://www.omdbapi.com/?s=${title}&apikey=${api}`
      );
      setMovies(response.data.Search);
    } catch (error) {
      setError(error.message);
    }
    setLoading(false);
  };

  const addToWatchlist = (movie) => {
    if (watchlist.some((m) => m.imdbID === movie.imdbID)) {
      toast.error("Movie already exists in the watchlist");
    } else {
      setWatchlist((pre) => [...pre, movie]);
      toast.success("Movie added to watchlist");
    }
  };

  const removeFromWatchlist = (imdbID) => {
    setWatchlist(watchlist.filter((movie) => movie.imdbID !== imdbID));
    toast.error("Movie removed from watchlist");
  };

  return (
    <MovieContext.Provider
      value={{
        movies,
        watchlist,
        loading,
        error,
        fetchMovies,
        addToWatchlist,
        removeFromWatchlist,
      }}
    >
      {children}
    </MovieContext.Provider>
  );
};

export default MovieProvider;
